import React, { useState, useEffect } from "react";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import DataGridComponent from "../Widgets/DataGridComponent";
import { t } from "react-i18nify";
import {
    requiredCell,
} from "../../js/utils/inputValidations";
import { useSelector } from "react-redux";
import { useEditionRightsPerUserStatus } from "../../js/utils/customHooks";
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { FilterToolbar } from "../Widgets/Custom Inputs/Select";
import { userRole } from "../../js/constants/selectOptions";


const ActiveUsersGrid = ({ label, baseURL, ...props }) => {
    const apiRef = useGridApiRef();
    const locale = useSelector(state => state.i18n.locale);

    const [lastTwelveMonths, setLastTwelveMonths] = useState([]);
    const [selectedUserRole, setSelectedUserRole] = useState(t("diagram.AllUsers"));

    const languages = {
        'ENG': 'en-US',
        'FRA': 'fr-FR',
        'SPA': 'es-ES',
        'POR': 'pt-PT',
        'NLD': 'nl-NL',
        'DEU': 'de-DE'
    };

    /* eslint-disable */

    const getLastTwelveMonths = () => {
        const months = [];
        const currentDate = new Date();
        
        for(let i = 0; i < 12; i++) {
            const month = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
            const year = month.getFullYear().toString().slice(-2);
            const monthName = month.toLocaleString(languages[locale], { month: 'short' });
            months.push({
                field: `Month${i+1}`,
                headerName: `${monthName}-${year}`,
                flex: 1,
                editable: true,
                renderCell: params => {
                    const connect = params.row[`Month${i+1}`]
                    return connect ? <CheckIcon style={{ color:"green" }} /> : <ClearIcon style={{ color:"red" }} />
                }
            });
        }

        return months;
    };

    useEffect(() => {
        setLastTwelveMonths(getLastTwelveMonths());
    }, []);

    /* eslint-disable */

    const editingRights = useEditionRightsPerUserStatus([
        "EntityManager",
        "Editor",
        "Contributor",
    ]);    
    
    const gridSpecificColumns = [
        {
            field: "IGG",
            headerName: "IGG",
            flex: 1,
            editable: true,
            minWidth: 90,
            preProcessEditCellProps: params => {
                const hasError = requiredCell(params, apiRef, "IGG", "IGG");
                return { ...params.props, error: hasError };
            }
        },
        {
            field: "Fullname",
            headerName: t("common.FullName"),
            flex: 1,
            editable: true,
            minWidth: 120
        }
    ].concat(lastTwelveMonths);


    return (
        <DataGridComponent
            apiRef={apiRef}
            baseURL={"user/GetUsersStats"}
            label={label}
            gridSpecificColumns={gridSpecificColumns}
            initialState={{
                sorting: {
                    sortModel: [{ field: "Fullname", sort: "asc" }],
                },
            }}
            toolbar={{
                newFilter: (
                    <FilterToolbar
                        options={userRole.map(e => ({
                            ...e,
                            label: t(`diagram.${e.label}`)
                        }))}
                        disableClearable
                        placeholder={t("diagram.AllUsers")}
                        value={selectedUserRole}
                        onChange={(e, value) =>
                            value
                                ? setSelectedUserRole(t(`diagram.${value.value}`))
                                : setSelectedUserRole("")
                        }
                    />
                ),
            }}
            paramURL={
                selectedUserRole
                    ? `filter[Role]=${selectedUserRole}`
                    : r.filter.allFilter
            }
            editingRights={editingRights}
            getDetailPanelHeight={() => "auto"}
            isAddDisabled={true}
            hideActionColumn={true}
            {...props}
        />
    );
};

export default ActiveUsersGrid;
